/**
 * ÐÐ±ÑÑÐ² ÑÐ²ÑÐ·Ð¸ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼, Ð° Ð½Ðµ Ð¾ÑÐ¸Ð±ÐºÐ° Ð±Ð¸Ð·Ð½ÐµÑ-Ð»Ð¾Ð³Ð¸ÐºÐ¸: Ð±ÑÐ°ÑÐ·ÐµÑ Ð´Ð¾ API Ð½Ðµ
 * Ð´Ð¾ÑÑÑÑÐ°Ð»ÑÑ. Ð§Ð°ÑÐµ Ð²ÑÐµÐ³Ð¾ ÑÑÐ¾ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐº Ð±ÑÐºÐµÐ½Ð´Ð° Ð¿ÑÐ¸ Ð²ÑÐºÐ°ÑÐºÐµ â Ð¾Ð½ Ð·Ð°Ð½Ð¸Ð¼Ð°ÐµÑ
 * Ð¾ÐºÐ¾Ð»Ð¾ Ð¿Ð¾Ð»Ð¼Ð¸Ð½ÑÑÑ, Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð² ÑÑÐ¾Ñ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð¸ ÑÑÐµÐº AxiosError.
 */
export const isConnectionError = (error) => {
  const message = error?.message || '';
  const code = error?.details?.code || '';
  return (
    message === 'Network Error' ||
    code === 'ERR_NETWORK' ||
    code === 'ECONNABORTED' ||
    /timeout/i.test(message)
  );
};
